export const sliceEvery = (array: any[], size: number) => {
  let step = 0,
    sliceArr = [],
    len = array.length
  while (step < len) {
    sliceArr.push(array.slice(step, (step += size)))
  }
  return sliceArr
}
